"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Toast = (function () {
    function Toast(type, message, title, data) {
        this.type = type;
        this.message = message;
        this.title = title;
        this.data = data;
        this.config = {
            dismiss: 'auto',
            enableHTML: false,
            titleClass: '',
            messageClass: '',
            toastLife: 3000,
            showCloseButton: false,
        };
    }
    return Toast;
}());
exports.Toast = Toast;
//# sourceMappingURL=toast.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-toastr/src/toast.js
// module id = 332
// module chunks = 3